// removed by extract-text-webpack-plugin
module.exports = {"Body":"Body---2-bIA","Container":"Container---1q6Fy","Header":"Header---uJXlN","Title":"Title---2h1OS","Menu":"Menu---1bCvE","MenuItems":"MenuItems---3mrlB","MenuItem":"MenuItem---6cag9","HeaderContent":"HeaderContent---1MkJR","AvatarsList":"AvatarsList---2HD4h","MultiAvatars":"MultiAvatars---2THWg","AvatarWrapper":"AvatarWrapper---3_sRl"};


//////////////////
// WEBPACK FOOTER
// ./src/scripts/components/shared/MessagePreviews/WelcomeMessage/WelcomeMessageHeader/style.styl
// module id = QMlG
// module chunks = 89